import React from "react";
import S from "./MessageDate.styled";
const MessageDate = ({ date }) => {
    const doubleDigits = (n) => String(n).padStart(2, "0");
    return (React.createElement(S.Wrapper, null, `${doubleDigits(date.getHours())}:${doubleDigits(date.getMinutes())}`));
};
export default MessageDate;
//# sourceMappingURL=MessageDate.js.map